const SvgIconStability = (props) => (
  <svg viewBox="0 0 123 105" xmlns="http://www.w3.org/2000/svg">
    <path d="m60 0 60 105H0L60 0Z" fill="#3763FF" />
    <ellipse cx={92.37} cy={52.127} rx={30.435} ry={30.372} fill="#D0AE86" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m75.316 26.969 30.069 52.622A30.367 30.367 0 0 1 92.37 82.5c-16.809 0-30.435-13.599-30.435-30.373 0-10.467 5.306-19.698 13.38-25.159Z"
      fill="#F06C22"
    />
  </svg>
);

export default SvgIconStability;
